/**
 * Returns the MUI Chip color for an order status value.
 * @param {string} status - Order status (settled, pending, refunding, refunded)
 * @returns {'success' | 'error' | 'warning' | 'default'} MUI Chip color
 */
export function getOrderStatusColor(status) {
    switch (status) {
        case 'settled':
            return 'success';
        case 'pending':
            return 'warning';
        case 'refunding':
        case 'refunded':
            return 'error';
        default:
            return 'default';
    }
}
